import axios from 'axios'

const API_PATH = `${process.env.REACT_APP_ENV === 'local' ? '' : '/tsp'}/manage/BatteryMission`;

// 電池管家
const getDropdownActivity = async (resource) =>
    await axios.get(`${API_PATH}/dropdown/activity`, resource);

const getActivity = async (resource) => 
    await axios.get(`${API_PATH}/activity`, { params: resource });

const getActivityDetailed = async (resource) => 
    await axios.get(`${API_PATH}/activity/${resource.activityMasterId}`);

const getActivityWhitelist = async (resource) => 
    await axios.get(`${API_PATH}/activity/${resource.activityMasterId}/whitelist/export/csv` , { responseType: 'blob' });

const getActivityHistory= async (resource) => 
    await axios.get(`${API_PATH}/activity/${resource.activityMasterId}/history`, { params: resource });

const postActivityFixed = async (resource) =>
    await axios.post(`${API_PATH}/activity/vehiclesFixed`, resource , { headers: {'Content-Type': 'multipart/form-data' }});

const postActivityFestival= async (resource) =>
    await axios.post(`${API_PATH}/activity/vehiclesFestival`, resource , { headers: {'Content-Type': 'multipart/form-data' }});

const putActivityFixed = async (resource) =>
    await axios.put(`${API_PATH}/activity/vehiclesFixed/${resource.activityMasterId}`, resource);

const putActivityFestival= async (resource) =>
    await axios.put(`${API_PATH}/activity/vehiclesFestival/${resource.activityMasterId}`, resource);

const putActivityEnabled= async (resource) =>
    await axios.put(`${API_PATH}/activity/status/enabled/${resource.activityMasterId}`, resource);

const putActivityDisabled= async (resource) =>
    await axios.put(`${API_PATH}/activity/status/disabled/${resource.activityMasterId}`, resource);

const postActivityPush = async (resource) =>
    await axios.post(`${API_PATH}/tasks/${resource}/push`, resource);

const postActivityRefresh = async (resource) =>
    await axios.post(`${API_PATH}/tasks/${resource}/refresh`, resource);

const getActivityTasksList = async (resource) =>
    await axios.get(`${API_PATH}/tasks`, { params: resource });

const getActivityTasksDetail = async (resource) =>
    await axios.get(`${API_PATH}/tasks/${resource.vehicleTasksMasterId}`);

const getMileageTotal = async (resource) =>
    await axios.get(`${API_PATH}/upload/vehicles/mileageTotal`, { params: resource });

const getChargingDaily = async (resource) =>
    await axios.get(`${API_PATH}/upload/vehicles/chargingDaily`, { params: resource });

const getLowBatteryChargingDaily = async (resource) =>
    await axios.get(`${API_PATH}/upload/vehicles/lowBatteryChargingDaily`, { params: resource });

const getBatteryMissionVehicleReward = async (resource) =>
    await axios.get(`${API_PATH}/vehicleReward`, { params: resource });

const getBatteryMissionSendBounsHistory = async (resource) =>
    await axios.get(`${API_PATH}/${resource.vId}/sendBounsHistory` , { params: resource });

const postBatterySendBouns = async (resource) =>
    await axios.post(`${API_PATH}/vehicleReward/${resource.vehicleRewardPointsId}/sendBouns` , resource);

const getVehicleRewardExportCSV = async (resource) =>
    await axios.get(`${API_PATH}/vehicleReward/export/csv`, { params: resource , responseType: 'blob' });

export { getDropdownActivity, getActivity , getActivityDetailed , getActivityWhitelist , getActivityHistory , postActivityFixed , postActivityFestival , putActivityFixed , putActivityFestival , putActivityEnabled , putActivityDisabled , postActivityPush , postActivityRefresh , getActivityTasksList , getActivityTasksDetail , getMileageTotal , getChargingDaily , getLowBatteryChargingDaily , getBatteryMissionVehicleReward , getBatteryMissionSendBounsHistory , postBatterySendBouns , getVehicleRewardExportCSV }
